import { connect } from "react-redux";
import GoogleAnalytics4ActivationView from "./GoogleAnalytics4ActivationView.jsx";
import { activateAccount } from "src/legacy/redux/actions/integrations/googleAnalytics4.jsx";
import {trackAdoptionMetricsForPluginConnectedEvent} from 'src/legacy/redux/actions/adoption';

const mapStateToProps = (state, ownProps) => {
  return {
    activating:
      state.legacyRootReducer.settings.integrations.googleAnalytics4.activation.activating,
    error: state.legacyRootReducer.settings.integrations.googleAnalytics4.activation.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    activateAccount: (configuration) => {
      return dispatch(activateAccount(configuration));
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName))
    }
  };
};

const GoogleAnalytics4ActivationPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(GoogleAnalytics4ActivationView);

export default GoogleAnalytics4ActivationPage;
